<template>
  <div id="app">
    <Menu v-show="$store.state.menuShow"/>
    <div id="main" :style="$store.state.menuShow?'padding-bottom: 50px;':''">
      <router-view/>
    </div>
  </div>
</template>
<script>


import Menu from "@/components/public/menu";

export default {
  name: "App",
  components: {Menu},
  methods: {
    menuIsShow() {
      this.$store.state.menuOpen ? this.$store.state.menuShow = this.$route.path.indexOf("/informationDetail") === -1 && this.$route.path.indexOf("/strategyDetail") === -1 && this.$route.path.indexOf("/advertisement") === -1 && this.$route.path.indexOf("/calendarDataDetail") === -1 && this.$route.path.indexOf("/login") === -1 && this.$route.path.indexOf("/userAgreement") === -1 && this.$route.path.indexOf("/collection") === -1 && this.$route.path.indexOf("/subscribe") === -1 && this.$route.path.indexOf("/forget") === -1 && this.$route.path.indexOf("/modify") === -1 && this.$route.path.indexOf("/chart") === -1 && this.$route.path.indexOf("/cut") === -1: this.$store.state.menuShow = false
    },
    checkLogin() {
      if(!(localStorage.getItem('member_uuid') && localStorage.getItem('api_token'))){
        this.$store.state.SignedIn = false

      }

    }
  },

  created() {
    this.menuIsShow()
    this.checkLogin()

  },
  updated() {
    this.menuIsShow()
  },
  mounted() {
    this.$store.commit('watchClient')



  }
}

</script>
<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}


</style>